import { render, staticRenderFns } from "./A7PainelResumo.vue?vue&type=template&id=bbb4d7d0&scoped=true&"
import script from "./A7PainelResumo.vue?vue&type=script&lang=js&"
export * from "./A7PainelResumo.vue?vue&type=script&lang=js&"
import style0 from "./A7PainelResumo.vue?vue&type=style&index=0&id=bbb4d7d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb4d7d0",
  null
  
)

export default component.exports